import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

$(function () {
    const visitInquiryAvailableDaysFrom = document.getElementById("visitInquiryAvailableDaysFrom");
    if (!visitInquiryAvailableDaysFrom) {
        return;
    }
    const visitInquiryAvailableDaysFromValue = visitInquiryAvailableDaysFrom.value;
    const currentDate = new Date();
    const firstAvailableDate = new Date(currentDate);
    firstAvailableDate.setDate(currentDate.getDate() + parseInt(visitInquiryAvailableDaysFromValue));
    const formattedFirstAvailableDate = firstAvailableDate.toISOString().split("T")[0]; // 日付と時刻を区切って年月日だけ取得

    flatpickr(".datepicker", {
        locale: Japanese,
        dateFormat: "Y/m/d",
        minDate: formattedFirstAvailableDate,
        static: true,
        disableMobile: true // NOTE: モバイルでネイティブの日付選択を無効化。enable オプションを設定した場合はデフォルト true となる
    });
});
